export default __webpack_public_path__ + "static/media/meet-ph.06b388d0.jpg";